import axios from "axios";
import qs from "qs";
import { CourseParams } from "./urls";
import { workState } from "./index";

interface WeekTimePaper {
    paperId: string;
    homeWordStatus: workState;
    endTime: string;
    paperName: string;
}

export function getWeekTimePaper(weekTimeId: number, params: CourseParams) {
    return axios
        .post<SuccessData<WeekTimePaper | null>>(
            "/student/getWeekTimePaper",
            qs.stringify({ ...params, weekTimeId })
        )
        .then(res => res.data.data);
}
